import { Component, Input, Output, EventEmitter } from '@angular/core';
import OtherProduct from 'src/app/model/product/other-product/other-product';
import { Project } from 'src/app/model/project/project';
import Company from 'src/app/model/company/company';
import PMSColor from 'src/app/model/company/pmscolor';
import { Subject } from 'rxjs';
import { ProjectDisplayObservableService } from 'src/app/services/project-display-observable.service';

@Component({
  selector: 'other-product-form',
  templateUrl: './other-product-form.component.html',
  styleUrls: ['./other-product-form.component.scss']
})
export class OtherProductFormComponent {
  @Input()
  inputProject: Project;

  @Input()
  inputProduct: OtherProduct;

  @Input()
  involvedCompanies: Company[];

  @Input()
  pmsColorAdded: Subject<PMSColor>;

  @Input()
  client = false;

  @Input()
  fromOldSystem = false;

  @Input()
  disabled = false;

  @Output()
  outputOtherProduct = new EventEmitter<OtherProduct>();

  constructor(
    private projectDisplayObservableService: ProjectDisplayObservableService
  ) {}

  otherProductNameChange(value) {
    this.inputProduct.otherProductName = value;
    this.projectDisplayObservableService
      .getProductMaterialChangedSubscribable()
      .next();
    this.outputOtherProduct.emit();
  }

  otherProductMaterialChange(value) {
    this.inputProduct.otherProductMaterial = value;
    this.outputOtherProduct.emit();
  }

  heightChange(value) {
    this.inputProduct.height = value;
    this.outputOtherProduct.emit();
  }

  widthChange(value) {
    this.inputProduct.width = value;
    this.outputOtherProduct.emit();
  }

  layoutDescriptionChange(value) {
    this.inputProduct.layoutDescription = value;
    this.outputOtherProduct.emit();
  }
}
